import { _ } from "libs";

import React, { useState } from "react";
//https://github.com/react-component/slider
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";
import cx from "classnames";

type State = number[];
type OnButtonValueChange = (name: string, value: State) => void;

const DropdownSlider = ({
	name,
	placeholder,
	title,
	emptyValue = [],
	onChange,
	isOpen = false,
	onClick,
	value,
}: {
	name: string;
	placeholder: string;
	title: string;
	emptyValue: State;
	onChange: OnButtonValueChange;
	isOpen?: boolean;
	onClick?;
	value?: State;
}) => {
	const [state, setState] = useState(value || emptyValue);
	const start = 1;
	const end = 100;

	const onRangeChange = (value: number[]) => {
		setState(value);
	};

	const onAfterRangeChange = (value: number[]) => {
		onChange(name, value);
	};

	const isDefaultState = (): boolean => {
		return state[0] === emptyValue[0] && state[1] === emptyValue[1];
	};

	const getSelectedValuesLabels = () => {
		if (isDefaultState()) {
			return placeholder;
		}

		if (state[0] == start && state[1] != end) {
			return _("playerFilter.age.below") + " " + state[1];
		}

		if (state[0] != start && state[1] == end) {
			return _("playerFilter.age.above") + " " + state[0];
		}

		return (
			<>
				{_("playerFilter.age.title")} {state[0]} &ndash; {state[1]}
			</>
		);
	};

	const className = cx("filterAttribute", {
		open: isOpen,
		closed: !isOpen,
		active: !isDefaultState(),
	});

	return (
		<div className={className}>
			<div className="filterValue" onClick={onClick}>
				{getSelectedValuesLabels()}
			</div>
			<div className="filterOptions filterRange">
				<h6>{title}</h6>
				<div className="sliderWrapper">
					<Range
						min={emptyValue[0]}
						max={emptyValue[1]}
						step={1}
						defaultValue={emptyValue}
						value={state}
						onChange={onRangeChange}
						onAfterChange={onAfterRangeChange}
					/>
				</div>
			</div>
		</div>
	);
};

export default DropdownSlider;
